/**
 * 발사체 잔상(트레일) 파라미터 + 스폰 스로틀 — 순수(Phaser 비의존).
 * 잔상 = 발사체와 같은 텍스처/tint의 ADD 블렌드 고스트가 짧게 페이드("발광 구체 + 잔상" 가독 지시).
 * 비용: 발사체 1기당 동시 고스트 ≈ FADE/INTERVAL ≈ 3개 — 트윈 fire-and-forget.
 */
export const TRAIL_INTERVAL_MS = 45;
export const TRAIL_FADE_MS = 140;
export const TRAIL_START_ALPHA = 0.3;
export const TRAIL_END_SCALE = 0.45;

/** 마지막 스폰 후 interval 경과 여부 — preUpdate 매 프레임 호출되는 스로틀 판정. */
export function shouldSpawnGhost(
  nowMs: number,
  lastSpawnMs: number,
  intervalMs: number = TRAIL_INTERVAL_MS,
): boolean {
  return nowMs - lastSpawnMs >= intervalMs;
}
